module.exports = __webpack_public_path__ + "img/videointerview.16f443f2.png";